import { useTranslation } from "react-i18next";
import { H3 } from "components/Typography/text.styled";
import { FontFamily} from "config/font";
import { OrganizationalStructureOverview } from "./organizationalStructureOverview.component";
import { useOrganizationalStructureStore } from "web-apps/company/stores/organizationalStructureStore/organizationalStructureStore";
import { CreateWorkerModal } from "./createWorkerModal.component";
import { useState } from "react";
import { EmptyStructure } from "./emptyStructure.component";

export const OrganizationalStructure = () => {
  const { t } = useTranslation();
  const [state] = useOrganizationalStructureStore();
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <>
      <H3
        fontFamily={FontFamily.MontserratSemiBold}
        style={{ marginBottom: 0 }}
      >
        {t("OrganizationalStructure.Organization")}
      </H3>
      {!state.structure ? (
        <EmptyStructure type={"Entity"} />
      ) : (
        <OrganizationalStructureOverview entities={state.structure.entities} />
      )}
      <CreateWorkerModal
        showCreateModal={showCreateModal}
        setShowCreateModal={setShowCreateModal}
      />
    </>
  );
};
